import React from 'react';
import { bollard } from '../../../components/shared/vector-images';
import Text from '../../../components/shared/_deprecated/elements/Text/Text';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const layer = {
  displayName: 'Dock or wharf',
  synonyms: 'pontoon jetty landing',
  group: 'standardMarker',
  typeUrl: 'wharf',
  icon: {
    baseShape: bollard,
    iconColor: '#fff',
    markerColor: '#56AC5C',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'marine-facilities',
    order: 30,
  },
  standardMarkerOptions: {
    markerType: 'wharfMarker',
    allowCreation: true,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Dock or wharf',
      itemTitleFunction: (item) => (item && item.title) || 'Dock or wharf',
    },
    creationOptions: {
      menuText: 'Dock or wharf',
      newTitle: 'Dock or wharf',
      titlePlaceholder: 'Name of dock or wharf',
      markerTypeDescription: [
        <Text key="description-text-1" size="-1" paragraph>
          This marker is used to indicate the location of a wharf, dock,
          pontoon, public jetty or otherwise. Include information such as depth,
          contact details or any fees payable.
        </Text>,
        <Text key="description-text-2" size="-1" paragraph>
          Information provided should be factual. Once you submit this marker,
          you can add your personal experiences or questions as a comment
          underneath.
        </Text>,
      ],
      checkBoxItems: [
        { label: 'Floating dock', isActive: false },
        { label: 'Fixed wharf', isActive: false },
        { label: 'Suitable for small vessels <3m', isActive: false },
        { label: 'Suitable for medium vessels <10m', isActive: false },
        { label: 'Suitable for larger vessels >10m', isActive: false },
      ],
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType: layer.standardMarkerOptions.markerType,
    id: marker.id,
    displayChat: true,
    // displayChat: true, ?? TODO: need to add fix chat for wharfs
    displayUpVotes: false,
    title: 'Dock or wharf',
    description: 'Available for use by the general boating public',
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);

export default layer;
